export function afterSpending({dailyBudget}: CoreState, input: MoneyAmount): MoneyAmount {
  return Math.max(dailyBudget.amount - input, 0);
}
